import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Pages
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ThreadsPage from "@/pages/ThreadsPage";
import ThreadDetailPage from "@/pages/ThreadDetailPage";
import EvidencePage from "@/pages/EvidencePage";
import IntakePage from "@/pages/IntakePage";
import FunnelsPage from "@/pages/FunnelsPage";
import DealsPage from "@/pages/DealsPage";
import VehiclesPage from "@/pages/VehiclesPage";
import SettingsPage from "@/pages/SettingsPage";
import TestsPage from "@/pages/TestsPage";

// Layout
import Layout from "@/components/Layout";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-zinc-500 font-inter">Loading...</div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-zinc-500 font-inter">Loading...</div>
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="threads" element={<ThreadsPage />} />
        <Route path="threads/:id" element={<ThreadDetailPage />} />
        <Route path="evidence" element={<EvidencePage />} />
        <Route path="intake" element={<IntakePage />} />
        <Route path="funnels" element={<FunnelsPage />} />
        <Route path="deals" element={<DealsPage />} />
        <Route path="vehicles" element={<VehiclesPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="tests" element={<TestsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
